import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  getColumnsWidthStyles,
  getSharedAccordionStyles,
} from 'app/pages/loanApplication/LoanApplication.sharedStyles';
import LoanTabLayout from 'app/pages/loanApplication/LoanTabLayout';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

import { selectLoanKeyDates } from 'store/loanApplications/selectors';

import { UnderwritingTestIds } from '../../../Underwriting.testIds';

const KeyDates = ({ isLoading }) => {
  const theme = useTheme();
  const classes = useMemo(() => getSharedAccordionStyles(theme), [theme]);
  const columnsStyles = useMemo(() => getColumnsWidthStyles(theme, { columns: 4 }), [theme]);

  const { tridApplicationDate, ecoaDate, mcrApplicationDate, loanApplicationDate } =
    useSelector(selectLoanKeyDates);

  const isNoContent =
    !isLoading && !tridApplicationDate && !ecoaDate && !mcrApplicationDate && !loanApplicationDate;

  const tridApplicationDateDisplayValue = tridApplicationDate
    ? dayjs(tridApplicationDate).format(COMMON_DATETIME_FORMAT)
    : 'N/A';

  const ecoaDateDisplayValue = ecoaDate ? dayjs(ecoaDate).format(COMMON_DATETIME_FORMAT) : 'N/A';

  const mcrApplicationDateDisplayValue = mcrApplicationDate
    ? dayjs(mcrApplicationDate).format(COMMON_DATETIME_FORMAT)
    : 'N/A';

  const loanApplicationDateDisplayValue = loanApplicationDate
    ? dayjs(loanApplicationDate).format(COMMON_DATETIME_FORMAT)
    : 'N/A';

  return (
    <>
      <Typography gutterBottom className="mb-12 mt-24" component="div" variant="bold16">
        Key Dates
      </Typography>
      <LoanTabLayout
        isLightBackgroundLayout
        content={
          !isLoading ? (
            <Box className="w-full py-28 pb-0 pl-24 pr-4" sx={classes.accordionTop}>
              <Box className="flex md:hidden flex-col" sx={columnsStyles.wrapper}>
                <Typography variant="regular14">Trid Application Date</Typography>
                <Typography variant="regular14">ECOA Date</Typography>
                <Typography variant="regular14">MCR Application Date</Typography>
                <Typography variant="regular14">Loan Application Date</Typography>
              </Box>

              <Box
                className="flex flex-col md:flex-row"
                data-testid={UnderwritingTestIds.KEY_DATES_SECTION}
                sx={columnsStyles.wrapper}
              >
                <Typography variant="regular14">{tridApplicationDateDisplayValue}</Typography>
                <Typography variant="regular14">{ecoaDateDisplayValue}</Typography>
                <Typography variant="regular14">{mcrApplicationDateDisplayValue}</Typography>
                <Typography variant="regular14">{loanApplicationDateDisplayValue}</Typography>
              </Box>
            </Box>
          ) : null
        }
        id="key-dates-section"
        isEmptyContentPlaceholder={isNoContent}
        top={
          <Box className="w-full flex" sx={columnsStyles.wrapper}>
            <Typography variant="medium16">Trid Application Date</Typography>
            <Typography variant="medium16">ECOA Date</Typography>
            <Typography variant="medium16">MCR Application Date</Typography>
            <Typography variant="medium16">Loan Application Date</Typography>
          </Box>
        }
        useBottomButtons={false}
      />
    </>
  );
};

KeyDates.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default KeyDates;
